<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_sy3"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('noteManage_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button v-if="getLimit('noteManage_add_button')" @click="funcAdd">
          新增
        </el-button>
        <el-button
          v-if="getLimit('noteManage_export_button')"
          @click="funcExport"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          min-width="130"
          field="title"
          title="通知标题"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.title"
            placeholder="请输入通知标题"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          min-width="300"
          field="noticeContent"
          title="通知内容"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.noticeContent"
            placeholder="请输入通知内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          width="320"
          field="gmtCreated"
          title="创建时间"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('noteManage_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('noteManage_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('noteManage_pushShipper_button')"
            class="item"
            effect="dark"
            content="推送托运人"
            placement="top"
          >
            <vxe-button type="text" @click="funcPushShipper(scope.row.code)">
              <i class="el-icon-share" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('noteManage_pushDriver_button')"
            class="item"
            effect="dark"
            content="推送实际承运人"
            placement="top"
          >
            <vxe-button type="text" @click="funcPushDriver(scope.row.code)">
              <i class="el-icon-position" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="800"
      height="460"
      resize
    >
      <compAdd ref="addRef" @fatherComplete="fatherComplete" />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="800"
      height="460"
      resize
    >
      <compEdit ref="editRef" @fatherComplete="fatherComplete" />
    </vxe-modal>
    <vxe-modal
      v-model="modelPushShipperFlag"
      title="推送托运人选择"
      width="800"
      height="600"
      resize
    >
      <compPushShipper ref="pushShipperRef" @fatherComplete="fatherComplete" />
    </vxe-modal>
    <vxe-modal
      v-model="modelPushDriverFlag"
      title="推送实际承运人选择"
      width="800"
      height="600"
      resize
    >
      <compPushDriver ref="pushDriverRef" @fatherComplete="fatherComplete" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/noteManageAdd.vue";
import compEdit from "./components/noteManageEdit.vue";
import compPushShipper from "./components/noteManagePushShipper.vue";
import compPushDriver from "./components/noteManagePushDriver.vue";
import { getNoteOrSMSManageList, delNoteOrSMSManage } from "@/api/news";
export default {
  name: "NoteManageList",
  components: {
    compAdd,
    compEdit,
    compPushShipper,
    compPushDriver
  },
  data() {
    return {
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelPushShipperFlag: false,
      modelPushDriverFlag: false,
      exportObj: {
        exportUrl: "/ntocc-basic-api/notice/exportAppNotice", //导出接口
        name: "应用通知管理"
      },
      listQuery: {
        gmtCreatedRange: "",
        noticeType: 1,
        title: "",
        noticeContent: "",
        gmtCreatedStart: "",
        gmtCreatedEnd: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    // 列表
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getNoteOrSMSManageList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 新增
    funcAdd() {
      this.$refs.addRef.$refs["form"].resetFields();
      this.modelAddFlag = true;
    },
    // 编辑
    funcEdit(code) {
      this.modelEditFlag = true;
      this.$refs.editRef.getInfo(code);
    },
    // 删除
    funcDelete(codes) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          delNoteOrSMSManage({ codes }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 推送托运人
    funcPushShipper(code) {
      this.modelPushShipperFlag = true;
      this.$refs.pushShipperRef.findList(code);
    },
    // 推送实际承运人
    funcPushDriver(code) {
      this.modelPushDriverFlag = true;
      this.$refs.pushDriverRef.findList(code);
    },
    // 关闭弹框
    fatherComplete() {
      this.modelAddFlag = false;
      this.modelEditFlag = false;
      this.modelPushShipperFlag = false;
      this.modelPushDriverFlag = false;
      this.findList();
    }
  }
};
</script>

<style></style>
